import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import { render } from "react-dom";
import Image from "next/image";
import Link from "next/link";

import HeaderNav from "../../includes/HeaderNav";
import Footer from "../../includes/Footer";
import BookingSec from "./BookingCTA";

import ADMULogo from "../../../public/assets/img/partner-logos/admu.png";
import AngelesULogo from "../../../public/assets/img/partner-logos/angeles-university-logo.png";
import DLSULogo from "../../../public/assets/img/partner-logos/dlsu.png";
import DLSULipaLogo from "../../../public/assets/img/partner-logos/dlsu-lipa.png";
import EACLogo from "../../../public/assets/img/partner-logos/eac.png";
import FEULogo from "../../../public/assets/img/partner-logos/feu.png";
import InfinitLogo from "../../../public/assets/img/partner-logos/infinit-care.png";
import MapuaLogo from "../../../public/assets/img/partner-logos/mapua.png";
import MCULogo from "../../../public/assets/img/partner-logos/mcu.png";
import NULogo from "../../../public/assets/img/partner-logos/nu.png";
import OLFULogo from "../../../public/assets/img/partner-logos/olfu.png";
import PUPLogo from "../../../public/assets/img/partner-logos/pup.png";
import USTLogo from "../../../public/assets/img/partner-logos/ust-logo.png";

import ClientFamilySocial from "../../../public/assets/img/icons/clien-family-socialization.svg";
import CommunityOutreach from "../../../public/assets/img/icons/mental-health-icon.svg";
import AnnualClientSport from "../../../public/assets/img/icons/sport-icon.svg";
import RMHPSS from "../../../public/assets/img/icons/rmhpss.svg";

import PsychiatricServicesSlider from "./PsychiatricServicesSlider";
import PsychologicalServicesSlider from "./PsychologicalServicesSlider";
import OccupationalTherapySlider from "./OccupationalTherapySlider";
import SocialServiceSlider from "./SocialServiceSlider";
import InternshipProgramSlider from "./InternshipProgramSlider";
import AWCSlider from "./AWCSlider";
import ProgramsFamilySlider from "./ProgramsFamilySlider";

const Cisd = () => {
  return (
    <>
      {/* MAIN NAV */}
      <HeaderNav />

      {/* CISD HEADER */}
      <section className="lg:pt-[100px] pt-[85px]">
        <div className="bg-[url('/assets/img/cisd-header-2.png')] bg-bottom bg-cover bg-no-repeat lg:min-h-[550px] sm:min-h-[350px] min-h-[200px]"></div>
        <div className="max-w-screen-2xl mx-auto md:px-10 sm:px-8 px-6 mt-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="max-w-2xl lg:text-5xl sm:text-4xl text-3xl !leading-tight">
              Clinical and Intervention Services Department
            </h1>
            <p className="text-justify sm:text-lg text-base leading-relaxed border-t border-t-gray-300 pt-10 mb-4">
              The Clinical and Intervention Services Department (CISD) is the
              secondary program of the Association. It provides, an out-patient
              basis, social as well as psychological and psychiatric services
              and intervention to children, adolescents, and adults with
              emotional and behavioral problems and/or mental disorders. The
              CISD team also implements out-patient vocational and psychosocial
              therapeutic programs for mental health consumers.
            </p>
            <p className="text-justify sm:text-lg text-base leading-relaxed">
              The CISD provides holistic mental health services to clients and
              their families as well as client-centered intervention programs to
              children and adolescents with special needs. The CISD
              professionals work together as a multi-disciplinary team to ensure
              that the clients’ mental health needs are properly addressed. The
              evaluation, treatment, and therapeutic methods used by the CISD
              Team are responsive and based on the best practices in their
              respective fields of expertise.
            </p>
          </div>
        </div>
      </section>

      {/* CISD BODY */}
      <section className="mt-10 py-14">
        <div className="max-w-screen-2xl mx-auto md:px-10 sm:px-8 px-6">
          <div className="grid grid-cols-12">
            <div className="col-span-12">
              <p className="md:text-2xl text-xl mb-14">
                The following are the CISD Programs and Services:
              </p>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center pt-0 pb-12">
            <div className="col-span-1">
              <h2 className="md:text-3xl text-2xl text-blue font-semibold">
                I. Social Services (SS)
              </h2>
              <p className="text-justify sm:text-lg text-base mb-4">
                The Social Services is the frontline service of CISD which
                provides triaging and assistance to clients/service users and
                family members. The Social Services emphasizes the importance of
                the family in holistic client care and works not only with the
                client, but also strengthens the involvement of the family in
                the helping process. Through the Family Support Group (FSG), one
                of the programs under Social Services, family members and
                caregivers of the mental health consumers and clients are given
                opportunities to learn better ways of caring for mental health
                consumers as well as themselves by sharing their concerns with
                one another and attending psycho-educational or relevant
                learning sessions.
              </p>
              <p className="text-justify sm:text-lg text-base">
                The Social Services staff ensure that clients and their families
                are equipped with the knowledge and care skills needed in the
                management of their client-family members. The team evaluates
                the client’s needs and makes the necessary recommendations and
                referral to the members of the CISD multi-disciplinary team.
                Likewise, under the Social Services is the Medicine Program of
                the PMHAI and indigent clients are the priority beneficiary of
                the medicine program.
              </p>
            </div>
            <div className="col-span-1">
              <SocialServiceSlider />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
            <div className="col-span-1 lg:block hidden">
              <PsychiatricServicesSlider />
            </div>
            <div className="col-span-1">
              <h2 className="md:text-3xl text-2xl text-blue font-semibold">
                II. Psychiatric Services
              </h2>
              <p className="text-justify sm:text-lg text-base">
                Diagnostic and treatment services are provided by the CISD
                Psychiatrists, geared towards addressing the needs of clients
                with cognitive, emotional, and behavioural disorders. The
                Psychiatrists evaluate the clients’ condition, provide a
                diagnosis and recommend and/or implement various types of
                psychiatric interventions, including psychotherapy,
                pharmacotherapy, and other psychosocial interventions to address
                clients’ concerns.
              </p>
            </div>
            <div className="col-span-1 lg:hidden block">
              <PsychiatricServicesSlider />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
            <div className="col-span-1">
              <h2 className="md:text-3xl text-2xl text-blue font-semibold">
                III. Psychological Services
              </h2>
              <p className="text-justify sm:text-lg text-base mb-4">
                The CISD Psychologists conduct quality psychological evaluation,
                consultation, psychotherapy and/or counseling services to child,
                adolescent, and adult clients needing diagnostic assessment and
                specialized intervention services.
              </p>
              <p className="text-justify sm:text-lg text-base">
                Psychologists also develop specialized intervention services for
                companies, institutions or people-at-risk in order to evaluate
                and address their specific mental health concerns.
              </p>
            </div>
            <div className="col-span-1">
              <PsychologicalServicesSlider />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
            <div className="col-span-1 lg:block hidden">
              <InternshipProgramSlider />
            </div>
            <div className="col-span-1">
              <h2 className="md:text-3xl text-2xl text-blue font-semibold">
                IV. Internship Program
              </h2>
              <p className="text-justify sm:text-lg text-base">
                The CISD is a specialized training venue for undergraduate and
                graduate students of Psychology, Counseling, and Occupational
                Therapy. The CISD Internship program is geared to help students
                develop competence in providing Clinical and Mental Health
                Services to clients.
              </p>
            </div>
            <div className="col-span-1 lg:hidden block">
              <InternshipProgramSlider />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
            <div className="col-span-1">
              <h2 className="md:text-3xl text-2xl text-blue font-semibold">
                V. Intervention Services
              </h2>
              <div className="lg:pl-7 pl-0">
                <h3 className="sm:text-xl text-lg font-semibold">
                  A. Intervention Services for Children and Youth - Allied
                  Mental Health Services
                </h3>
                <h4 className="sm:text-xl text-lg font-semibold font-DidotItalic mb-4">
                  Occupational Therapy and Special Education
                </h4>
                <p className="text-justify sm:text-lg text-base mb-4">
                  Occupational therapy is a client-centered health profession
                  concerned with promoting health and well-being through
                  engagement in occupations with the primary goal of enabling
                  individuals, groups, or communities in participating in
                  everyday activities such as self-care, play, leisure, work,
                  community tasks, and social participation that they want to
                  do, need to do, and/or expected to do.
                </p>
                <p className="text-justify sm:text-lg text-base mb-4">
                  Special Education Tutorials is a one-on-one learning session
                  and activities tailored to meet the needs of individuals in
                  the area of learning and academic skills.
                </p>
                <p className="text-justify sm:text-lg text-base">
                  PMHAI’s CISD offers OT and SpEd sessions to clients referred
                  by our multi-disciplinary team, as well as those referred by
                  health professionals or educators from other agencies and
                  institutions.
                </p>
              </div>
            </div>
            <div className="col-span-1">
              <OccupationalTherapySlider />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
            <div className="col-span-1 lg:block hidden">
              <AWCSlider />
            </div>
            <div className="col-span-1">
              <div className="mb-6">
                <h3 className="sm:text-xl text-lg font-semibold">
                  B. Adult Work Center (AWC)
                </h3>
                <p className="text-justify sm:text-lg text-base">
                  The Adult Work Center operates an out-patient day care
                  facility and sheltered workshop for recovered and recovering
                  psychiatric patients/ Mental Health Consumers.
                </p>
              </div>
              <div className="mb-6">
                <h3 className="sm:text-xl text-lg font-semibold">
                  C. Psychosocial Program
                </h3>
                <p className="text-justify sm:text-lg text-base">
                  The IS provides relevant psychosocial management and
                  intervention programs that aim to restore, improve and
                  maintain the psychosocial functioning of the Mental Health
                  Consumers.
                </p>
              </div>
            </div>
            <div className="col-span-1 lg:hidden block">
              <AWCSlider />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 grid-cols-1 gap-12 items-center py-12">
            <div className="col-span-1">
              <div className="">
                <h3 className="sm:text-xl text-lg font-semibold">
                  D. Programs for the Family
                </h3>
                <p className="text-justify sm:text-lg text-base">
                  One of the AWC’s unique features is its inclusive program for
                  the family of Mental Health Consumers. The Center recognizes
                  the importance of family involvement in the therapeutic
                  process of the mental health consumers. They conduct regular
                  meetings and consultation with the family members and
                  caregivers to keep them updated about the concerns of the
                  consumers.
                </p>
              </div>
            </div>
            <div className="col-span-1">
              <ProgramsFamilySlider />
            </div>
          </div>
        </div>
      </section>

      {/* SPECIAL PROJECTS */}
      <section className="bg-sky-50 py-20">
        <div className="max-w-screen-2xl mx-auto md:px-10 sm:px-8 px-6">
          <div className="grid grid-cols-1 mb-10">
            <h2 className="text-center text-3xl font-semibold mb-4">
              Special Projects
            </h2>
            <p className="text-center text-lg">
              Aside from the three major services under CISD, the department
              also organizes the following special projects:
            </p>
          </div>
          <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-6">
            <div className="p-8 bg-white rounded-xl shadow-xl">
              <div className="w-[100px] h-[100px] mx-auto bg-gray-100 rounded-full p-4 mb-6">
                <Image
                  src={ClientFamilySocial}
                  alt="Client-Family Socialization"
                />
              </div>
              <h3 className="font-semibold text-lg text-blue text-center leading-6 md:min-h-[85px] min-h-auto">
                Client-Family <br /> Socialization
              </h3>
              <p className="leading-6 text-justify">
                A special Thanksgiving Party held during Christmas Season
                organized for the clients and their families.
              </p>
            </div>
            <div className="p-8 bg-white rounded-xl shadow-xl">
              <div className="w-[100px] h-[100px] mx-auto bg-gray-100 rounded-full p-4 mb-6">
                <Image
                  src={CommunityOutreach}
                  alt="Community Outreach Program"
                />
              </div>
              <h3 className="font-semibold text-lg text-blue text-center leading-6 md:min-h-[85px] min-h-auto">
                Community <br /> Outreach Program
              </h3>
              <p className="leading-6 text-justify">
                The CISD Team of Psychiatrists, Psychologists, Counselors and
                Social Workers provide community-based diagnostic and
                intervention services to indigent clients who do not have access
                to mental health services.
              </p>
            </div>
            <div className="p-8 bg-white rounded-xl shadow-xl">
              <div className="w-[100px] h-[100px] mx-auto bg-gray-100 rounded-full p-4 mb-6">
                <Image src={AnnualClientSport} alt="Annual Client Sportsfest" />
              </div>
              <h3 className="font-semibold text-lg text-blue text-center leading-6 md:min-h-[85px] min-h-auto">
                Annual Client <br /> Sportsfest
              </h3>
              <p className="leading-6 text-justify">
                A special sports event for clients held in the dry season. This
                annual activity is conducted face-to-face and put on hold
                depending on restrictions imposed by certain situations (e.g.,
                COVID-19 pandemic).
              </p>
            </div>
            <div className="p-8 bg-white rounded-xl shadow-xl">
              <div className="w-[100px] h-[100px] mx-auto bg-gray-100 rounded-full p-4 mb-6">
                <Image
                  src={RMHPSS}
                  alt="Remote Mental Health and Psychosocial Support"
                />
              </div>
              <h3 className="font-semibold text-lg text-blue text-center leading-6 md:min-h-[85px] min-h-auto">
                Remote Mental Health and Psychosocial Support (RMHPSS)
              </h3>
              <p className="leading-6 text-justify">
                The CISD collaborates with the Education and Advocacy Research
                Department through its Volunteer Program to provide
                solution-focused services with clients in need of immediate
                assistance and free services, especially for the indigent
                clients.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="bg-sky-50 pt-5 pb-20">
        <div className="max-w-screen-2xl mx-auto md:px-10 sm:px-8 px-6">
          <h2 className="text-center text-3xl font-semibold mb-10">
            Partnerships and Linkages
          </h2>
          <div className="sm:flex grid grid-cols-3 items-center justify-center flex-wrap sm:gap-8 gap-1 max-w-6xl mx-auto mb-5">
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={ADMULogo} alt="Ateneo De Manila University" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] ml-0 mr-auto">
                <Image src={AngelesULogo} alt="Angeles University" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] ml-0 mr-auto">
                <Image src={DLSULogo} alt="De La Salle University" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={DLSULipaLogo} alt="De La Salle University Lipa" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={EACLogo} alt="Emilio Aguinaldo College" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={FEULogo} alt="Far Eastern University" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={InfinitLogo} alt="Infinit Care" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={MapuaLogo} alt="Mapua University" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={MCULogo} alt="Manila Central University" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={NULogo} alt="National University" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={OLFULogo} alt="Our Lady of Fatima University" />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image
                  src={PUPLogo}
                  alt="Polytechnic University of the Philippines"
                />
              </div>
            </div>
            <div className="col-span-1">
              <div className="partner-logo-wrap max-w-[200px] mr-0 ml-auto">
                <Image src={USTLogo} alt="UST" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking CTA */}
      <BookingSec />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Cisd;
